

const QRCareCenter = {
	setLesson: () => Promise.resolve({})
}

export default QRCareCenter
